import { Slider } from '@/components/ui/slider';

interface Params {
  maxTotalPosition: number;
  cooldownSeconds: number;
}

interface Props {
  value: Params;
  onChange: (next: Params) => void;
  disabled?: boolean;
}

/**
 * 自由参数滑块 — §9.9 + openapi.yaml UpdateSymbolRequest 约束:
 *   - maxTotalPosition ≤ 5.0
 *   - cooldownSeconds ≤ 300
 */
export function ParamSliders({ value, onChange, disabled }: Props) {
  return (
    <div className="space-y-4">
      <Row
        label="毛持仓预警线"
        unit="lot"
        min={0.5}
        max={5.0}
        step={0.1}
        value={value.maxTotalPosition}
        onChange={(v) => onChange({ ...value, maxTotalPosition: v })}
        disabled={disabled}
        decimal={1}
      />
      <Row
        label="同向跟单冷却"
        unit="秒"
        min={0}
        max={300}
        step={5}
        value={value.cooldownSeconds}
        onChange={(v) => onChange({ ...value, cooldownSeconds: v })}
        disabled={disabled}
        decimal={0}
      />
    </div>
  );
}

interface RowProps {
  label: string;
  unit: string;
  min: number;
  max: number;
  step: number;
  value: number;
  onChange: (v: number) => void;
  disabled?: boolean;
  decimal: number;
}

function Row({ label, unit, min, max, step, value, onChange, disabled, decimal }: RowProps) {
  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between text-sm">
        <span className="text-ink-2">{label}</span>
        <div className="flex items-center gap-2 num">
          <span className="font-semibold text-ink-0">{value.toFixed(decimal)}</span>
          <span className="text-xs text-ink-3">{unit}</span>
        </div>
      </div>
      <Slider value={value} min={min} max={max} step={step} onChange={onChange} disabled={disabled} />
      <div className="flex justify-between text-[10px] text-ink-3 num">
        <span>{min.toFixed(decimal)}</span>
        <span>{max.toFixed(decimal)}</span>
      </div>
    </div>
  );
}
